var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKeyConditionGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0F4",
    stroke: "#0F4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.179.105c-2.66 0-4.813 2.15-4.813 4.806 0 1.603.783 3.02 1.992 3.894L.042 20.548c-.074.118-.034.293.084.368l2.946 1.872c.118.087.307.057.385-.067.078-.125.03-.316-.1-.385l-2.73-1.73 1.759-2.825 2.829 1.797c.08.06.188.07.279.026.09-.045.147-.136.149-.237 0-.1-.054-.193-.144-.24L2.67 17.33l5.131-8.24c.702.399 1.512.626 2.378.626 2.66 0 4.813-2.15 4.813-4.805 0-2.656-2.154-4.806-4.813-4.806zm0 .518c2.37 0 4.294 1.921 4.294 4.288 0 2.366-1.924 4.287-4.294 4.287-2.37 0-4.295-1.92-4.295-4.287S7.808.623 10.18.623z",
    transform: "translate(-170 -292) translate(160 123) translate(11 170)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyConditionGood);
export default __webpack_public_path__ + "static/media/icon-key-condition-good.c59fa083017ebe1d28c19489ce188a8f.svg";
export { ForwardRef as ReactComponent };